import { render, staticRenderFns } from "./popup-chanxian-do.vue?vue&type=template&id=00a4b57a&scoped=true"
import script from "./popup-chanxian-do.vue?vue&type=script&lang=js"
export * from "./popup-chanxian-do.vue?vue&type=script&lang=js"
import style0 from "./popup-chanxian-do.vue?vue&type=style&index=0&id=00a4b57a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4b57a",
  null
  
)

export default component.exports